import React from 'react';
import BannerComponent from '../../../components/ui/BannerComponent';

const BannerPage = () => {
  return (
    <div className="banner-page">
      <BannerComponent />
    </div>
  );
};

export default BannerPage;

